import { render, staticRenderFns } from "./ClubFun.vue?vue&type=template&id=570db9f4&scoped=true&lang=pug&"
import script from "./ClubFun.vue?vue&type=script&lang=js&"
export * from "./ClubFun.vue?vue&type=script&lang=js&"
import style0 from "./ClubFun.scss?vue&type=style&index=0&id=570db9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570db9f4",
  null
  
)

export default component.exports